<template>
    <div id="gwi-voucherRegister" class="app bg-gray">
        <div class="scroll">
            <section v-for="(item,index) in localIds" class="photo-section text-center" onclick="chooseLocalImage(index)">
                <!--<img v-if="item > 0" class="photo-img" :src="item"/>-->
                <img class="photo-img" src="../../../static/img/abctest.jpg"/>
                <!--<div v-else="" class="photo-tips">{{photoTips[index]}}</div>-->
            </section>
        </div>
        <section class="voucher-register-footer box">
            <button class="btn-ok" type="button" @click="submitImage">上传照片</button>
        </section>
    </div>
</template>
<script>
/* eslint-disable */
import utils from 'utils'
import voucherService from 'voucher.service'
import wechatService from 'wechat.service'
export default {
    components: {

    },
    data() {
        return {
            photoTips: ['请上传您身份证的正面照', '请上传您身份证的反面照', '请上传您本人半身正面照'],
            // 上一页面传递过来的绑定电子健康卡的输入信息
            voucherInfo : this.$store.state.paramModule.param.voucherRegister.voucherInfo,
            // 建卡人是否是儿童(儿童不需要上传身份证照片)
            isChild: false,
            // 微信API配置相关
            wechatConfig: {},
            // 证件正面，反面，半身照
            idCardFrontPhoto: -1,
            idCardReversePhoto: -1,
            manPhoto: -1,
            localIds: [-1, -1, -1],
            serverIds: [-1, -1, -1],
        }
    },
    mounted() {
        // 先判断是否是儿童(儿童没有身份证)，通过输入的身份证卡号来判断年龄
        this.isChild = utils.getAgeFromIdCardNo(this.voucherInfo.cardNo) < 18
        this.getWxConfigParams()
    },
    methods: {
        /**
         * 获取初始化微信API所需的参数(微信appId，签名等)
         */
        getWxConfigParams() {
            // 调用后台接口获取微信API所需要的appId等参数
            wechatService.getWechatConfig({
                url: 'pzwjw-imts.hngwmt.com',
                orgId: http.headers.common['organizationId'],
            }).then((res)=>{
                if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                    utils.alert(res.resultMsg)
                    return
                }
                this.wechatConfig = res.data
                console.log('wechatConfig = ' + JSON.stringify(this.wechatConfig))
                this.initWxAPI()
            })
        },
        /**
         * 初始化微信API
         */
        initWxAPI() {
            if (typeof(wx) === 'undefined') {
                console.log('由于微信版本兼容性问题，暂时无法上传照片')
                return
            }
            console.log('initWxAPI start ===============================')
            console.log('appId =' + this.wechatConfig.appId)
            console.log('timestamp =' + this.wechatConfig.timestamp)
            console.log('nonceStr =' + this.wechatConfig.nonceStr)
            console.log('signature =' + this.wechatConfig.signature)
            wx.config({
                debug: false,
                appId: this.wechatConfig.appId, // 必填，公众号的唯一标识
                timestamp: this.wechatConfig.timestamp, // 必填，生成签名的时间戳
                nonceStr: this.wechatConfig.nonceStr, // 必填，生成签名的随机串
                signature: this.wechatConfig.signature, // 必填，微信签名
                jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage'],// 必填，需要使用的JS接口列表
            })
            console.log('initWxAPI end ===============================')
        },
        /**
         * 用户选图、拍照
         * 返回localId(图片的本地ID)
         */
        chooseLocalImage(index) {
            wx.chooseImage({
                count: 1, // 可选图片最大数量，默认9
                sizeType: ['original', 'compressed'], // 指定是原图还是压缩图，默认都有
                sourceType: ['album', 'camera'], // 指定来源是相册还是相机，默认都有
                success: function (res) {
                    const localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                    console.log('选择图片成功，localIds = ' + localIds)
                    this.uploadImageToWx(localIds[0] ,index)
                }
            })
        },
        /**
         * 将用户选择的图片上传至微信服务器
         * 返回serverId(图片的微信服务器ID)
         */
        uploadImageToWx(localId, index) {
            wx.uploadImage({
                localId: localId, // 需要上传的图片的本地ID，由chooseImage接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success: function(res) {
                    const serverId = res.serverId
                    console.log('上传微信服务器成功，serverId = ' + serverId)
                    this.localIds.$set(index, localId)
                    this.serverIds.$set(index, serverId)
                },
            });
        },
        /**
         * 提交图片，将最终提交的图片以serverId的形式提交给后台，后台通过此serverId可以获取微信临时素材拿到图片
         */
        submitImage() {

        }

    },
}
</script>
<style lang="scss">
    .photo-section {
        margin: 0.5rem;
        height: 7rem;
        background-image: url(../../../static/img/add-card.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 3rem 3rem;
        padding: 0.5rem;
        .photo-tips {
            text-align: center;
            margin-top: 5rem;
        }
        .photo-img {
            height: 100%;
        }
    }
    .voucher-register-footer {
        margin-top: 1rem;
    }
</style>


// WEBPACK FOOTER //
// VoucherRegisterPhoto.vue?564a2228